import React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useUserSettingsWebSupplierGroup, useUserSettingsWebSupplierGroupValidator } from "../../@hooks"
import { userSettingsWebSupplierGroupFormData } from "../../@signals"


export default function WebSupplierGroupDrawerName() {
	const { handleChangeFormData } = useUserSettingsWebSupplierGroup()
	const { nameError } = useUserSettingsWebSupplierGroupValidator()

	return <TextFieldSeeker
		error={nameError}
		value={userSettingsWebSupplierGroupFormData.value?.name || ''}
		onChange={e => handleChangeFormData(e.target.value, 'name')}
	/>
}